import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Field } from "formik";
import * as yup from "yup";
import FormBody, { InputError } from "../../components/form/FormBody";
import instance from "../../utils/api_instance.util";
import { adminPasswordRules } from "../../utils/validation.util";

const schema = yup.object({
  password: adminPasswordRules,
  confirmpassword: yup.string().required("Confirm password is required").oneOf([yup.ref("password")], "Passwords do not match"),
});

const ResetPassword = () => {
  const [params] = useSearchParams();
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const token = params.get("token") || "";

  const onSubmit = async (values) => {
    if (saving) return;
    setSaving(true);
    try {
      const { data } = await instance.post("/api/v1/admin/auth/reset-password", {
        token,
        password: values.password,
      });
      setMessage(data?.message || "Password updated.");
    } catch (err) {
      setMessage(err.response?.data?.message || "We can't reach the server. Check your connection and try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="card mb-3">
                  <div className="card-body">
                    <h5 className="card-title text-center pb-0 fs-4">Reset Password</h5>
                    <FormBody initialValues={{ password: "", confirmpassword: "" }} validationSchema={schema} onSubmit={onSubmit}>
                      <div className="col-12 mb-3">
                        <label htmlFor="password" className="form-label">New password</label>
                        <Field type="password" className="form-control" id="password" name="password" autoComplete="new-password" />
                        <InputError name="password" />
                      </div>
                      <div className="col-12 mb-3">
                        <label htmlFor="confirmpassword" className="form-label">Confirm password</label>
                        <Field type="password" className="form-control" id="confirmpassword" name="confirmpassword" autoComplete="new-password" />
                        <InputError name="confirmpassword" />
                      </div>
                      <button className="btn btn-primary w-100" type="submit" disabled={saving || !token}>
                        {saving ? "Saving..." : "Update password"}
                      </button>
                    </FormBody>
                    {message ? <p className="small mt-3 mb-0">{message}</p> : null}
                    <div className="text-center mt-3">
                      <Link to="/login">Back to sign in</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ResetPassword;
